import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    user: {},
    isAuth: false,
    loading: false,
    error: null,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        temp: (state) => {
            console.log("temp");
        }

    },
});

export const { temp } = authSlice.actions;

export default authSlice.reducer;
